module.exports = __webpack_public_path__ + "static/media/bg_mario.d1f81475.mp3";